import React ,{useContext, useState} from 'react'
import './Calendar.css'
import AddDailyProbelmForm from './AddDailyProblemForm/AddDailyProbelmForm'
import DailySuggestionsList from './ProblemList/DailySuggestionsList'
import { AuthContext } from '../../../../context/authContext'


const Calendar = () => {
    const today = new Date()
    const [ChosenDay, setChosenDay] = useState((today.getDate()+1)%30)
    const {user}=useContext(AuthContext)
    
  return (
    <div className='Calendar-container'>
       <div className="Intro">
        <h1>🗓️ Calendar aka Daily Problem Center :</h1>
        <p>
          <b>Instructions : </b>
          Seeing the "Challenges" drop downs, you can't help but notice a daily problem section (that's mathtounsi specialty). So in here Admins and Educators suggest problems, and a vote is held until the day of the problem, the most voted one is live. 
        </p>
      </div>

      <div className="Body">
        <div className="DayButtons">
            <h2>{today.toLocaleString('en-US', { month: 'long' })} the :</h2>
            <div className="days-button-container">
<button onClick={()=>setChosenDay((today.getDate()+1)%30)} className={ChosenDay===(today.getDate()+1)%30?"Active":null}>{(today.getDate()+1)%30}</button>
            <button onClick={()=>setChosenDay((today.getDate()+2)%30)} className={ChosenDay===(today.getDate()+2)%30?"Active":null}>{(today.getDate()+2)%30}</button>
            <button onClick={()=>setChosenDay((today.getDate()+3)%30)} className={ChosenDay===(today.getDate()+3)%30?"Active":null}>{(today.getDate()+3)%30}</button>
            <button onClick={()=>setChosenDay((today.getDate()+4)%30)} className={ChosenDay===(today.getDate()+4)%30?"Active":null}>{(today.getDate()+4)%30}</button>
            <button onClick={()=>setChosenDay((today.getDate()+5)%30)} className={ChosenDay===(today.getDate()+5)%30?"Active":null}>{(today.getDate()+5)%30}</button>
            <button onClick={()=>setChosenDay((today.getDate()+6)%30)} className={ChosenDay===(today.getDate()+6)%30?"Active":null}>{(today.getDate()+6)%30}</button>
            <button onClick={()=>setChosenDay((today.getDate()+7)%30)} className={ChosenDay===(today.getDate()+7)%30?"Active":null}>{(today.getDate()+7)%30}</button>
            </div>
            
            <h2>{today.getFullYear()}</h2>
        </div>
<DailySuggestionsList chosenDate={new Date(today.getFullYear(), today.getMonth(), ChosenDay )} />
<hr />
<p style={{marginTop: "2vh"}}>Make this dynamic and propose problems to be posted for daily challenges. This would help select the best problems to garantie quality learning experience ! </p>
        {user?.role.trim().toLowerCase()==="moderator"?<p style={{color : "red",margin : "2vh",textAlign:"center"}}>This feature is not available to {user?.role}</p> : <AddDailyProbelmForm chosenDate={new Date(today.getFullYear(), today.getMonth(), ChosenDay)} />}
      </div>
    </div>
  )
}

export default Calendar
